import WindowHeader from './WindowHeader';

export default WindowHeader;